import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AssignmentService } from '../../shared/services/assignment.service';
@Component({
    moduleId: module.id,
    selector: 'assignment-notifi-detail',
    templateUrl: 'assignment-notifi-detail.html'
})

export class AssignmentNotifiDetailComponent implements OnInit {
    assignNoticationDetail: any;
    assignNoticationDetais: any;
    constructor(
        public activeModal: NgbActiveModal,
        public assiginService: AssignmentService
    ) { }
    ngOnInit() {
        this.getAssignNotificationDetail(this.assignNoticationDetail);
    }
    getAssignNotificationDetail(leadNoticationDetail) {

        const reqData: any = {
            date: new Date(leadNoticationDetail.updated_at),
            user_id: leadNoticationDetail.target_user_id
        }
        this.assiginService.getAssiNotificationDetail(reqData).subscribe(
            data => {
                this.assignNoticationDetais = data;
            }, error => {
                console.log(error);
            })
    }
}



// WEBPACK FOOTER //
// /home/ec2-user/jenkins/workspace/new-roamingse/prod/roamingse-frontend/src/app/views/notification-detail/assignment-notifi-detail.ts